
// import barba from '@barba/core';

export default class{

	constructor(){
        // barba.hooks.once((data) => {
        //     this.init()
        // })
        // barba.hooks.after((data) => {
        //     this.init()
        // });
        this.init()
    }
    init (){
        const faqTable = document.querySelectorAll(".c-accordion__faq--answer table");
        if (faqTable) {
            faqTable.forEach(function(e){
                e.outerHTML = '<div class="p-insurance__faq--table">' + e.outerHTML + '</div>';
            });   
        }
    }
}